import React, { useEffect, useMemo, useRef, useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import "../../../node_modules/leaflet/dist/leaflet.css";
import pin from "../../assets/image/pin.png";
import DisplayPosition from "./DisplayPosition";
import "./Location.css";
import SetViewOnClick from "./SetViewOnClick";
import MapSearch from "./MapSearch";

const Location = (props) => {

  const position = props.editDataValue ? props.editDataValue.split(",") : [35.723822, 51.407067];
  const animateRef = useRef(true);
  const [map, setMap] = useState(null);

  const displayMap = useMemo(
    () => (
      <div className="relative">
        <img
          src={pin}
          alt=""
          className="absolute top-[calc(50%-22px)] left-[calc(50%-12px)] translate-x-1/2 translate-y-1/2 z-[999]"
        />
        <MapContainer
          center={position}
          zoom={13}
          scrollWheelZoom={true}
          ref={setMap}>
            
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <SetViewOnClick animateRef={animateRef}/>
          <MapSearch/>
        </MapContainer>
      </div>
    ),
    []
  );

  return (
    <div>
      {map ? (
        <DisplayPosition
          map={map}
          inputData={props.inputData}
          item={props.item}
          setInputData={props.setInputData}
          index={props.index}
          HasManyKey={props.HasManyKey}
          HasManyInputData={props.HasManyInputData}
        />
      ) : null}
      {displayMap}
    </div>
  );

  // return (
  //   <MapContainer center={position} zoom={13} scrollWheelZoom={true}>
  //     <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
  //     <Marker position={position} icon={customIcon} draggable={true}></Marker>
  //     <SetViewOnClick animateRef={animateRef} />
  //     <DisplayPosition />
  //   </MapContainer>
  // );
};

export default Location;
